'use strict';

angular.module('shiftTraderApp')
    .service('WeightCalculationService', [function () {
      var GREEN_CUTOFF = 20;
      var ORANGE_CUTOFF = 100;
      var getLabelColorForAvailabilityIndex = function(availabilityIndex, blackoutInt) {
        if (blackoutInt > 0) {
          if (blackoutInt === 1) {
            return 'gray_gradient';
          } else if (blackoutInt === 3) {
            return 'charcoal_gradient';
          } else {
            console.log('whoops! no available option for this availabilityIndex return');
          }
        } else {
          if (availabilityIndex <= GREEN_CUTOFF) {
            return 'green_gradient';
          } else if (availabilityIndex <= ORANGE_CUTOFF && availabilityIndex > GREEN_CUTOFF) {
            return 'orange_gradient';
          } else if (availabilityIndex > ORANGE_CUTOFF) {
            return 'rouge_gradient';
          } else {
            return 'orange_gradient';
          }
        }
      };

      var USER_TARGET_HOURS_MAX = 60;
      var TARGET_HOURS_WEIGHTING_COEF = 2.0;

      var calculateTargetHoursWeighting = function(userTargetHours, hoursThisWeek, intervalLengthInHours) {
        // should return higher weight (lower priority) on people that are over target hours.
        // hoursThisWeek is # of hours this week w/o the currentTwix added in
        // intervalLengthInHours is length of currentTwix in hours that overlap with the week of interest

        var hoursToUse = hoursThisWeek + intervalLengthInHours;

        // don't allow a number larger than USER_TARGET_HOURS_MAX to affect the weighting dramatically
        var usableUserTargetHours = lodash.min([USER_TARGET_HOURS_MAX, userTargetHours]);

        if (hoursToUse > usableUserTargetHours) {
          // weight hours past target hours 4x as badly as hours less than target hours
          return (hoursToUse - usableUserTargetHours) * TARGET_HOURS_WEIGHTING_COEF * 4.0;
        } else {
          return (hoursToUse - usableUserTargetHours) * TARGET_HOURS_WEIGHTING_COEF;
        }
      };

      var OVERTIME_WEIGHTING_COEF = 60.0;
      var OVERTIME_PENALTY_PTS = 100; // go to RED/UNAVAILABLE immediately!
      var calculateOvertimeWeighting = function(overtimeThreshold, hoursThisWeek, intervalLengthInHours) {
        if ((hoursThisWeek + intervalLengthInHours) > overtimeThreshold) {
          return {
            weight: OVERTIME_PENALTY_PTS + (hoursThisWeek + intervalLengthInHours - overtimeThreshold) * OVERTIME_WEIGHTING_COEF,
            data: (hoursThisWeek + intervalLengthInHours - overtimeThreshold),
            type: 'Overtime'
          };
        } else {
          return {
            weight: 0,
            data: [],
            type: 'Overtime'
          };
        }
      };

      var OVERLAP_WEIGHTING_CEOF = 3.0;
      var calculateOverlapWithExistingWorkPeriods = function(workPeriods, currentTwix) {
        // checking to see if currentTwix overlaps with any work periods in 'workPeriods' argument
        var violations = [];
        if (workPeriods && workPeriods.length > 0) {
          var intersections = lodash.map(workPeriods, function (workPeriod) {
            if (currentTwix.overlaps(workPeriod.range_twix)) {
              // if the shifts overlap at all, figure out how long they overlap and put it on the array
              var inter = currentTwix.intersection(workPeriod.range_twix);
              if (Math.abs(inter.length('minutes')) > 0) {
                violations.push({
                  'intersection':inter,
                  'workPeriod':workPeriod
                });
              }

              return Math.abs(inter.length('minutes'));
            } else {
              return 0;
            }
          });
          //if no intersections are found then set a zero length array or pay the consequences with _.reduce...
          if (intersections.length === 0) {
            intersections = [0];
          }

          return {
            weight: OVERLAP_WEIGHTING_CEOF * lodash.reduce(intersections, function(sum, num) {
              return sum + num;
            }),
            data: violations,
            type: 'ExistingWorkPeriodOverlap'
          };
        } else {
          return {
            weight: 0,
            data: [],
            type: 'ExistingWorkPeriodOverlap'
          };
        }
      };

      var MULTI_SHIFT_WEIGHTING_COEF = 0.1; //0.075; // per minute. Equiv to 4.5pts/hour
      var MULTI_SHIFT_PENALTY_PTS = 0; // points to add if it happens at all
      var calculateMultiShift = function(workPeriods, currentDateTwix, shift) {
        // console.log('calculateMultiShift', workPeriods, currentDateTwix, shift);
        var shifts = [];
        if (workPeriods && workPeriods.length > 0) {
          var intersections = [];
          // don't add weight to the person if they would have less than 12 hours on this day
          var hoursToday = lodash.reduce(lodash.map(workPeriods, function(wp) {
            if (shift.$isWorkPeriod() && wp.id === shift.id) {
              return 0;
            }

            var inter = currentDateTwix.intersection(wp.range_twix);
            if (Math.abs(inter.length('minutes') > 0)) {
              return inter.length('minutes') / 60.0;
            } else {
              return 0;
            }
          }), function(sum, num) {
            return sum + num;
          });

          var shiftTwixInter = currentDateTwix.intersection(shift.range_twix);


          intersections = lodash.map(workPeriods, function (workPeriod) {
            if (currentDateTwix.overlaps(workPeriod.range_twix)) {
              // if a shift overlaps with the current date being scheduled let's add it onto the array
              var inter = currentDateTwix.intersection(workPeriod.range_twix);
              if (Math.abs(inter.length('minutes')) > 0) {
                shifts.push({
                  intersection: inter,
                  workPeriod: workPeriod
                });
              }

              if ((hoursToday + (Math.abs(shiftTwixInter.length('minutes')) / 60.0)) > 12) {
                return Math.abs(inter.length('minutes'));
              } else {
                return 0;
              }
            } else {
              return 0;
            }
          });

          //if no intersections are found then set a zero length array or pay the consequences with _.reduce...
          if (intersections.length === 0) {
            intersections = [0];
          }

          if (shifts.length === 0) {
            //if there are no shifts that day then then there shouldn't be any penalty
            MULTI_SHIFT_PENALTY_PTS = 0;
          }

          return {
            weight: MULTI_SHIFT_PENALTY_PTS + MULTI_SHIFT_WEIGHTING_COEF * lodash.reduce(intersections, function(sum, num) {
              return sum + num;
            }),
            data: shifts,
            type: 'MultiShift'
          };
        } else {
          return {
            weight: 0,
            data: [],
            type: 'MultiShift'
          };
        }
      };

      return {
        getLabelColorForAvailabilityIndex: getLabelColorForAvailabilityIndex,
        calculateTargetHoursWeighting: calculateTargetHoursWeighting,
        calculateOvertimeWeighting: calculateOvertimeWeighting,
        calculateOverlapWithExistingWorkPeriods: calculateOverlapWithExistingWorkPeriods,
        calculateMultiShift: calculateMultiShift
      };

    }]);
